import { cn } from '@app/utils/cn';
import { Tabs } from '@typings';
import React from 'react';

import { Tab } from './Tab';

interface Props {
  tabs: Tabs.Tab[];
  tablistName: string;
  selectedId: string;
  onChange: (id: string) => void;
  className?: string;
  tabClassName?: string;
  isFluid?: boolean;
  dataTestId?: string;
}

export const TabList = ({ tabs, tablistName, selectedId, onChange, className, tabClassName, isFluid = false, dataTestId }: Props) => {
  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <div
      className={cn('flex flex-grow flex-nowrap border-b border-neutral-90', className)}
      aria-label={tablistName}
      data-testid={dataTestId}
    >
      {tabs.map(tab => {
        const isSelected = selectedId === tab.id;

        return (
          <Tab
            isFluid={isFluid}
            key={tab.id}
            tabParameters={tab}
            isSelected={isSelected}
            onChange={handleChange}
            tablistName={tablistName}
            className={tabClassName}
          />
        );
      })}
    </div>
  );
};
